import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { IOrgModel } from "@/model";

/**
 * 部门类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class OrgService extends ServiceBase {
    /**
     * 新增部门
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addOrg(data: IOrgModel): Promise<IHttpResponse> {
        let response = await this.apis.addOrg({ data });
        return response;
    }

    /**
     * 删除部门
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteOrg(id: number): Promise<IHttpResponse> {
        let response = await this.apis.deleteOrg({ urlPath: { id } });
        return response;
    }

    /**
     * 修改部门
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async editOrg(data: IOrgModel): Promise<IHttpResponse> {
        let response = await this.apis.editOrg({ data });
        return response;
    }

    /**
     * 获取机构分页数据
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getOrgPage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getOrgPage({ data });
        return response;
    }

    /**
     * 获取机构树
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getOrgTree(): Promise<IHttpResponse> {
        let response = await this.apis.getOrgTree();
        return response;
    }

    /**
     * 获取机构列表
     * @param pid 父id
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getOrgList(pid?: number): Promise<IHttpResponse> {
        let response;
        if (pid) {
            response = await this.apis.getOrgList({
                params: { pid }
            });
        } else {
            response = await this.apis.getOrgList();
        }
        return response;
    }
}
